import React, { useMemo } from 'react';
import OrganizationAnalyticsBarChart from './OrganizationAnalyticsBarChart';
import { mapIdsToLabels } from './chartUtils';

const OrganizationChatterTotalMessagesByChatterChart = ({ data, chatterLabelMap, pending }) => {
  const { categories, series } = useMemo(
    () => ({
      categories: mapIdsToLabels(data?.chatterIds, chatterLabelMap),
      series: [{ name: 'Messages', data: data?.messages || [] }],
    }),
    [data, chatterLabelMap],
  );

  return (
    <OrganizationAnalyticsBarChart
      title="Total Messages By Chatter"
      subtitle="Message volume for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select creators and chatters to load message totals."
      valueType="number"
    />
  );
};

export default OrganizationChatterTotalMessagesByChatterChart;
